<template>
    <div>
        <!-- 头部logo与导航 -->
        <div class="header"
            style="background: #fff;width: 100%; height: 7.5rem; display: flex; justify-content: center; align-items: center;">
            <div style="display: flex; justify-content: space-between; align-items: center;width: 81%;">
                <div style="display: flex; align-items: center;">
                    <img :src="headerData.logo" alt="Logo" style="width: 3.85rem; height: 3.85rem;">
                    <span class="logoTitle">益巨科技</span>
                </div>
                <div style="display: flex; flex-direction: row;">
                    <span v-for="(item, index) in headerData.title" :key="index"
                        style="margin-left: 1.25rem;font-size: 2.5rem;" @click="goToPage(item.url)">{{
                            item.name }}</span>
                </div>
            </div>
        </div>
        <!-- 公司介绍 -->
        <div class="company_profile" :style="{ backgroundImage: 'url(' + Company_Profile.bgImg + ')' }">
            <div class="container">
                <div style="display: flex; flex-direction: column;padding-top: 5rem;">
                    <span style="font-size: 2.25rem;font-weight: 400;color: #fff;">{{ Company_Profile.title1 }}</span>
                    <span style="font-size: 4.375rem;font-weight: 700;color: #fff;padding-top: 1.25rem;">{{
                        Company_Profile.title2 }}</span>
                </div>
                <!-- 描述部分 -->
                <div v-if="filteredData1.length > 0"
                    style="padding-top: 2.5rem;display: flex;flex-wrap: wrap;justify-content: center; align-items: center;">
                    <div v-for="(item, index) in filteredData1" :key="index"
                        style="display: flex; align-items: center; min-width: 15.625rem; flex-grow: 1;">
                        <img :src="item.img" alt="Logo" style="width: 2.1875rem; height: 2.1875rem;">
                        <span
                            style="font-size: 1.25rem;font-weight: 400;color: #fff;padding-left: 1.6rem; white-space: nowrap;">{{
                                item.content }}</span>
                    </div>
                </div>
                <!-- 选项 -->
                <div v-if="filteredData2.length > 0"
                    style="padding-top: 9.6875rem;display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center;">
                    <div v-for="(item, index) in filteredData2" :key="index"
                        style="width: 18.3125rem; height: 6.25rem; border-radius: 0.450625rem; border-width: 0.048125rem; background: #FFFFFFCC; display: flex; justify-content: center; align-items: center;"
                        @click="goTouristCardProject(item)">
                        <div style="display: flex; align-items: center;">
                            <span style="color: #303030;font-size: 1.6875rem;font-weight: 700;">{{ item.name }}</span>
                            <img :src="item.img" style="width: 4.375rem; height: 4.375rem;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 介绍2 -->
        <div style="width: 100%;height:25rem;background: #d9e7ff;border: 1px solid red;" v-if="ProjectData.length > 0">
            <div class="container"
                style="display: flex;justify-content: center;align-items: center;height: 25rem;width: 100%;">
                <div class="container" style="width: 100%;">
                    <div style="display: flex;justify-content: center;align-items: center;">
                        <div v-for="(item, index) in ProjectData" :key="index"
                            :class="['option', { 'option-hover': hoverIndex === index }]"
                            @mouseover="hoverIndex = index" @mouseout="hoverIndex = null"
                            style="display: flex;justify-content: center;align-items: center;width: 21.0625rem;height: 8.75rem;border-radius: 0.9375rem;margin-left: 1.25rem;">
                            <div v-if="hoverIndex !== index" style="display: flex;align-items: center;">
                                <span style="font-size: 2.35rem;font-weight: 500;color: #0078FF;">0{{ index + 1
                                }}</span>
                                <span style="font-weight: 500;font-size: 1.35rem;color: #000;margin-left: 0.5rem;">{{
                                    item.title }}</span>
                            </div>
                            <div style="display: flex;justify-content: center;align-items: center;" v-else>
                                <span style="font-weight: 500;font-size: 1.35rem;color: #000;margin-left: 0.5rem;">{{
                                    item.description }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 旅游卡介绍 -->
        <div class="travel_introduction"
            :style="{ backgroundImage: 'url(' + card_introduction1.img + ')', height: card_introduction1.img ? '103.625rem' : 0, }">
        </div>
        <!-- 旅游小程序 -->
        <div class="travel_app"
            :style="{ backgroundImage: 'url(' + card_introduction2.img + ')', height: card_introduction2.img ? '62.65rem' : 0, }">
            <img v-if="card_introduction2.img"
                src="https://lcd-img-hangzhou.oss-cn-hangzhou.aliyuncs.com/TravelWebsite/consulting_service.png" alt=""
                @click="goToApp" />
        </div>
        <!-- 文章 -->
        <div v-if="articles.length > 0"
            style="width: 100%; height: 61.25rem; display: flex; justify-content: center; align-items: center;">
            <div class="container">
                <div class="travel-articles">
                    <div class="title" style="display: flex; flex-direction: column; align-items: self-start;">
                        <span style="font-size: 1.625rem; font-weight: 700; color: #000;">旅游文章</span>
                        <div style="width: 6.3125rem; height: 0.375rem; background-color: #0078ff; border: none;"></div>
                        <div style="width: 100%; height: 0.0625rem; background-color: #ccc; border: none;"></div>
                    </div>
                    <div class="article-list">
                        <div v-for="(article, index) in articles" :key="index" class="article-item"
                            @click="openArticle(article)">
                            <div
                                style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                                <img :src="article.picUrl" alt="Article Image" class="article-image" />
                                <div class="article-content">
                                    <h3>{{ article.title }}</h3>
                                    <p class="article-meta">
                                        <span>{{ article.browseCount }}阅读</span>
                                        <span>{{ article.author }}</span>
                                        <span>{{ article.createTime }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <div v-if="filteredData3.length > 0" class="footer" :style="{ backgroundImage: currentBackgroundImage }">
            <div class="menu-container" @click="selectCategory">
                <div v-for="(category, index) in filteredData3" :key="index"
                    :class="['menu-item', { selected: selectedCategory === category.name }]"
                    :data-category="category.name">
                    {{ category.name }}
                </div>
            </div>
        </div>
        <!-- 底部-单图 -->
        <div class="travel_introduction"
            :style="{ backgroundImage: 'url(' + footer_introduction_one.img + ')', height: footer_introduction_one.img ? '50.625rem' : 0, }">
        </div>
        <!-- 备案号 -->
        <div style="width: 100%;text-align: center;"><a href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank" style="color: #ccc;">粤ICP备2026023850号</a></div>

        <!-- 固定悬浮窗 -->
        <div v-if="fixed_position && fixed_position.img" style="position: fixed;top: 40.725rem;right: 3.125rem;">
            <img :src="fixed_position.img" alt="wechat" style="width: 7rem;height: 12rem;" />
        </div>
        <el-dialog title="" :visible.sync="dialogVisible" width="30%">
            <div v-if="card_introduction2 && card_introduction2.img1"
                style="display: flex;justify-content: center;align-items: center;">
                <img :src="card_introduction2.img1" style="width: 25rem;height: 25rem;" alt="wechat" />
            </div>
            <span v-else style="display: flex;justify-content: center;align-items: center;">暂无数据</span>
        </el-dialog>
    </div>
</template>

<script>
import { getTemplate, getArticle } from '@/api/index';
export default {
    data() {
        return {
            hoverIndex: null,
            articles: [],
            selectedCategory: null, // 默认不选择任何一项，将在数据加载后设置
            categories: [], // 存储从后端获取的分类数据
            dialogVisible: false,
            headerData: {}, //网站头部数据
            Company_Profile: {
                bgImg: '',       // 背景图
                title1: '',
                title2: '',
                data: [],         // 描述数据
                data2: []         // 白框选项数据
            }, //公司介绍数据
            Project_Introduction: null, //项目介绍数据
            card_introduction1: null, //旅游卡介绍数据1
            card_introduction2: null, //旅游卡介绍数据2
            footer_introduction: null, //网站底部数据
            footer_introduction_one: null, //网站底部数据-单图
            fixed_position: null,
        };
    },
    computed: {
        ProjectData() {
            return (this.project_introduction || []).filter(
                item => item.title && item.description
            );
        },
        filteredData1() {
            return (this.Company_Profile.data1 || []).filter(
                item => item.img && item.name
            );
        },
        filteredData2() {
            return (this.Company_Profile.data2 || []).filter(
                item => item.img && item.name
            );
        },
        currentBackgroundImage() {
            if (!this.selectedCategory) return '';
            const selectedCategory = this.categories.find(category => category.name === this.selectedCategory);
            return selectedCategory ? `url(${selectedCategory.img})` : '';
        },
        filteredData3() {
            return (this.categories || []).filter(
                item => item.name
            );
        },
    },
    mounted() {
        // 页面加载时获取数据
        this.getTemplate();
        this.getArticle();
    },
    methods: {
        getTemplate() {
            getTemplate().then(res => {
                let info = res.data.data;
                let webData = JSON.parse(info.property);
                console.log(webData, 'webData');
                this.headerData = webData.headerData;
                this.Company_Profile = {
                    ...this.Company_Profile, // 保留默认值以防某些字段缺失
                    ...webData.Company_Profile // 覆盖真实数据
                };
                this.Project_Introduction = webData.project_introduction;
                this.card_introduction1 = webData.card_introduction1;
                this.card_introduction2 = webData.card_introduction2;
                this.footer_introduction = webData.footer_introduction;
                this.footer_introduction_one = webData.footer_introduction_one;
                this.fixed_position = webData.fixed_qrcode;
                this.categories = this.footer_introduction.data;
                // 设置默认选中的分类为第一个
                if (this.categories.length > 0) {
                    this.selectedCategory = this.categories[0].name;
                }
            })
        },
        goTouristCardProject(item) {
            switch (item.url) {
                case 'introduce':
                    this.$router.push({ name: 'introduce', params: { img: item.img1 } });
                    break;
                case 'cooperate':
                    this.$router.push({ name: 'cooperate', params: { img: item.img1 } });
                    break;
                case 'income':
                    this.$router.push({ name: 'income', params: { img: item.img1 } });
                    break;
                case 'feedback':
                    this.$router.push({ name: 'feedback', params: { img: item.img1 } });
                    break;
            }
        },
        getArticle() {
            let deptId = 838;
            getArticle(deptId).then(res => {
                this.articles = res.data.rows;
            })
        },
        goToApp() {
            this.dialogVisible = true;
        },
        selectCategory(event) {
            const categoryName = event.target.getAttribute('data-category');
            if (categoryName) {
                this.selectedCategory = categoryName;
            }
        },
        openArticle(item) {
            if (item.type == 2) {
                window.open(item.content, '_blank');
            } else {
                this.$router.push({ name: 'article', params: { id: item.id } });
            }
        },
        goToPage(url) {
            // window.open(url, '_blank');
            console.log(url);
        },
    },
};
</script>

<style scoped>
.container {
    width: 80%;
    margin: 0 auto;
}
.logoTitle{
    color: #000;
    font-size: 3rem;
    margin-left: 20px;
}

.option {
    transition: background-color 0.3s ease;
    border: 0.09375rem solid #0078FF;
}

.option-hover {
    background-color: #ffeba2;
    border: 0.09375rem solid #ffeba2;
}

.company_profile {
    width: 100%;
    height: 37rem;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.travel_introduction {
    width: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.travel_app {
    width: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
}

.travel_app img {
    width: 12.375rem;
    height: 3.6875rem;
    position: absolute;
    top: 52.3rem;
    right: 21.6rem;
}


.travel-articles {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
    padding: 1.25rem;
    border-radius: 1.875rem;
}

.title {
    display: flex;
    align-items: center;
    margin-bottom: 1.25rem;
}

.title span {
    font-size: 1rem;
    font-weight: bold;
    color: #333;
    margin-right: 0.625rem;
}

.title hr {
    width: 100%;
    height: 0.125rem;
    background-color: #007bff;
    border: none;
}

.article-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;
}

.article-item {
    display: flex;
    align-items: center;
}

.article-image {
    width: 15.625rem;
    height: 10rem;
    object-fit: cover;
    margin-right: 0.625rem;
}

.article-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    height: 8rem;
}

.article-content h3 {
    font-size: 1.625rem;
    margin: 0 0 0.3125rem;
}

.article-meta {
    font-size: 0.75rem;
    color: #999;
    display: flex;
    justify-content: space-between;
    align-self: self-start;
    width: 80%;
    margin: 0;
}

.article-meta span {
    margin-right: 0.625rem;
}

.more-button {
    text-align: right;
    margin-top: 1.25rem;
}

.more-button a {
    color: #007bff;
    text-decoration: none;
}

.footer {
    width: 100%;
    height: 45.5rem;
    background-size: cover;
    background-position: center;
    position: relative;
}

.menu-container {
    position: absolute;
    top: 15.5rem;
    right: 16.0625rem;
    width: 12.25rem;
    height: 10.75rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #fff;
}

.menu-item {
    width: 100%;
    height: 3rem;
    line-height: 3rem;
    padding: 0 1.375rem;
    cursor: pointer;
    transition: background-color 0.3s ease;

}

.menu-item.selected {
    background-color: #3a3f48;
}

@media (max-width: 768px) {
    .home {
        padding: 1.6rem;
    }
}
</style>